import React, { forwardRef } from 'react';
import styled from 'styled-components';

const UpArrow = styled.svg`
  fill: var(--cvna-color-blue-2);
  color: var(--cvna-color-blue-2);
  width: 15px;
  height: 18px;
`;

type OwnProps = React.SVGProps<SVGSVGElement>;

// TODO if vdp-pinned-nav wins we need to delete this icon
const UpArrowIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <UpArrow viewBox="0 0 15 18" ref={ref} {...props}>
    <path
      d="M14.53,5.51,8.64.42a1.76,1.76,0,0,0-2.28,0L.47,5.51a1.34,1.34,0,0,0,0,2,1.73,1.73,0,0,0,2.28,0L6,4.59V16.5a1.5,1.5,0,0,0,3,0V4.62l3.23,2.93a1.73,1.73,0,0,0,2.28,0A1.34,1.34,0,0,0,14.53,5.51Z"
      fillRule="evenodd"
    />
  </UpArrow>
));

export default UpArrowIcon;
